import React, {useState ,useCallback, useEffect} from 'react';
import { walletQueries } from '../../graphql/queries'
import { useQuery} from '@apollo/react-hooks'
import Modal from '@mui/material/Modal'
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CustomSpinner from '../CustomSpinner';
import { PurchaseBNZ } from '../../components'
import "./CustomTable.css";
import { useHistory } from 'react-router-dom';

const CustomTable = props => {
  const {data, loading, headers,demandModal, acceptModal, refuseModal, page, totalPages, changePage, prevPage, nextPage} = props

  const history = useHistory()
  const [content, setContent] = useState()
  const [pagination, setPagination] = useState()

  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [servicePrice, setServicePrice] = useState('')
  const [planData, setPlanData] = useState('')

  const { data: walletData, refetch: refetchMyWallet } = useQuery(walletQueries.GET_MY_WALLET)

  const { loading: loadingPlanData } = useQuery(walletQueries.GET_MY_SUBSCRIPTION,{
    variables: {
      subscriptionType: 'planos-bonuz',
      planIdentifier: 'bonuz-plans'
    },
    onCompleted(data){
      setPlanData(data.subscription)
    }
  })

  const createPagination = (input) => {
    let page = 0
    let pagesArray = []
    while (page < input) {
      pagesArray[page] = page + 1
      page += 1
    }
    setPagination(pagesArray)
  }

  const goToDetails = (id) => {
    history.push(`/dashboard/serviços/detalhes/proposta/${id}?proposal`)
  }

  const openModal = useCallback((price) => {
    setServicePrice(price)
    setModalIsOpen(true)
  }, [])

  const closeModal = useCallback(() => {
    setModalIsOpen(false)
    refetchMyWallet()
  }, []) // eslint-disable-line

  useEffect(() => {
    if(data){
      setContent(data)
      createPagination(totalPages)
    }
  }, [data]) // eslint-disable-line

  // Garantir que a página atual seja sempre visível em ambos os temas
  useEffect(() => {
    if (loading || !page) return

    const ensureActivePageVisibility = () => {
      const paginationWrapper = document.querySelector('.proposals-pagination')
      if (!paginationWrapper) return

      const buttons = paginationWrapper.querySelectorAll('.custom-table-proposals-pagination-button-number')
      buttons.forEach(button => {
        const buttonText = button.textContent?.trim()
        if (!buttonText) return

        const pageNumber = parseInt(buttonText, 10)
        const isCurrentPage = !isNaN(pageNumber) && pageNumber === page

        if (isCurrentPage) {
          button.classList.add('proposals-active-page')
          button.setAttribute('data-active', 'true')
          
          // Forçar estilo da página atual
          button.style.setProperty('color', '#FFFFFF', 'important')
          button.style.setProperty('background-color', '#F14F5C', 'important')
          button.style.setProperty('border-color', '#F14F5C', 'important')
          button.style.setProperty('font-weight', '600', 'important')
        } else {
          button.classList.remove('proposals-active-page')
          button.removeAttribute('data-active')
          // Remover estilos inline quando não for ativo
          button.style.removeProperty('color')
          button.style.removeProperty('background-color')
          button.style.removeProperty('border-color')
          button.style.removeProperty('font-weight')
        }
      })
    }

    // Executar após renderização
    const timeoutId1 = setTimeout(ensureActivePageVisibility, 50)
    const timeoutId2 = setTimeout(ensureActivePageVisibility, 200)
    const timeoutId3 = setTimeout(ensureActivePageVisibility, 500)
    
    // Observar mudanças na paginação
    const observer = new MutationObserver(() => {
      setTimeout(ensureActivePageVisibility, 50)
    })
    const paginationWrapper = document.querySelector('.proposals-pagination')
    if (paginationWrapper) {
      observer.observe(paginationWrapper, { 
        childList: true, 
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      })
    }

    return () => {
      clearTimeout(timeoutId1)
      clearTimeout(timeoutId2)
      clearTimeout(timeoutId3)
      observer.disconnect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, loading, pagination])


  return (
    <Box className="custom-table-proposals-wrapper">
      <div className="container">
        <table className="custom-table-proposals-table">
          <thead className="custom-table-proposals-thead">
            <tr>
              {headers && headers.length ? (
                headers.map((item, index) => (
                  <th>{item.title}</th>
                ))
              ) : (
                <th colSpan={100}>{` `}</th>
              )}
            </tr>
          </thead>
          <tbody className="custom-table-proposals-tbody">
            {!loading && !loadingPlanData && content ? (
              content.length ? (
                content.map((item, index) => {
                  return (
                  item.isAuction ? (
                    item.demandBids.length > 0 ? (
                      item.demandBids.map((bidsItem, bidsIndex) => (
                        <tr>
                          <td>
                            <button onClick={()=> demandModal(item._id, bidsItem._id)}>
                              #{item.code}
                            </button>
                          </td>
                          <td>
                            <button onClick={()=> goToDetails(item._id)}>
                              {item.fullDescription}
                            </button>
                          </td>
                          <td>
                            <button onClick={()=> goToDetails(item._id)}>
                              {bidsItem.deadline ? `${bidsItem.deadline} d/u` : '-'}
                            </button>
                          </td>
                          <td>
                            <button onClick={()=> goToDetails(item._id)}>
                              {bidsItem.price
                                ? `${bidsItem.price} BNZs${bidsItem.isBNZAdquired || bidsItem.isBNZAdquired === null ? ' (Adquirido)' : ''}`
                                : '-'}
                            </button>
                          </td>
                          <td>
                            <Box className="custom-table-proposals-buttons-container">
                              {
                                (
                                  (bidsItem.isBNZAdquired === true || bidsItem.isBNZAdquired === null || planData?.planIdentifier === 'plano-premium' || planData?.planIdentifier === 'plano-platinum') && 
                                    parseFloat(walletData?.wallet?.balance) >= parseFloat(bidsItem.price)
                                ) ||
                                (
                                  (bidsItem.isBNZAdquired === false) &&
                                    parseFloat(walletData?.wallet?.balance + walletData?.wallet?.creditsBonuzPlans) >= parseFloat(bidsItem.price)
                                ) ? (
                                  <>
                                    <Button onClick={()=> refuseModal(bidsItem._id)} className="custom-table-proposals-refuse-button">
                                      Recusar
                                    </Button>
                                    <Button onClick={() => acceptModal(bidsItem._id)} className="custom-table-proposals-accept-button">
                                      Aceitar
                                    </Button>
                                  </>
                                ) : (
                                  <>
                                    <Box className="custom-table-proposals-buttons-container">
                                      {'Você não possui saldo de BNZ suficiente para aprovar essa proposta.'}
                                    </Box>
                                    <Button onClick={() => openModal(bidsItem.price)} className="custom-table-proposals-accept-button">
                                      Comprar BNZ
                                    </Button>
                                  </>
                                )
                              }
                            </Box>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr className="no-bids-found">
                        <td>
                          <button onClick={()=> goToDetails(item._id)}>
                            #{item.code}
                          </button>
                        </td>
                        <td>
                          <button onClick={()=> goToDetails(item._id)}>
                            {item.fullDescription}
                          </button>
                        </td>
                        <td>
                          <button onClick={()=> goToDetails(item._id)}>
                            {item.deadline ? `${item.deadline} d/u` : '-'}
                          </button>
                        </td>
                        <td>
                          <button onClick={()=> goToDetails(item._id)}>
                            {item.price ? `${item.price} BNZs` : '-'}
                          </button>
                        </td>
                        <td>
                          <Box className="custom-table-proposals-buttons-container">
                            Não há propostas para essa demanda. Aguarde propostas dos advogados.
                          </Box>
                        </td>
                      </tr>
                    )
                  )
                  : null
                  )
                })
              ) : (
                <tr>
                  <td colSpan={100}>Nenhum registro encontrado!</td>
                </tr>
              )
            ) : (
              <tr>
                <td colSpan={100}><CustomSpinner /></td>
              </tr>
            )}
          </tbody>
          <tfoot className="custom-table-proposals-tfoot">
            <tr>
              <td colSpan={100}>
                <Box className="proposals-pagination">
                  <IconButton onClick={() => prevPage()} className="custom-table-proposals-pagination-button-arrow">
                    <ChevronLeftIcon />
                  </IconButton>
                  {pagination && pagination.length ? (
                    pagination.map((item, index) => (
                      <Button
                        key={index}
                        onClick={() => changePage(item)}
                        className={`custom-table-proposals-pagination-button-number ${item === page ? 'proposals-active-page' : ''}`}
                        data-active={item === page ? 'true' : 'false'}
                      >
                        {item}
                      </Button>
                    ))
                  ) : (
                    <Button className="custom-table-proposals-pagination-button-number proposals-active-page" data-active="true">
                      1
                    </Button>
                  )}
                  <IconButton onClick={() => nextPage()} className="custom-table-proposals-pagination-button-arrow">
                    <ChevronRightIcon />
                  </IconButton>
                </Box>
              </td>
            </tr>
          </tfoot>
        </table>
        <Modal
          open={modalIsOpen}
          onClose={() => {
            closeModal()
          }}
          disableAutoFocus
          sx={{zIndex: '9999'}}
        >
          <PurchaseBNZ
            closeParentModal={() => {
              closeModal()
            }}
            servicePrice={servicePrice}
          />
        </Modal>
      </div>
    </Box>
  )
}

export default CustomTable
